import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router, Params, ActivatedRoute} from '@angular/router';
import {TransactionReturnService} from './transaction-return.service';

@Component({
    selector: 'transaction-return',
    template: require('./transaction-return.component.html'),
    providers: [TransactionReturnService]
})

export class SuperUserTransactionReturnComponent implements OnInit {
    
    transactionKey: string;
    paymentFailed:boolean = false;
    router: Router;

    constructor(private _transactionReturnService: TransactionReturnService, location: Location, _parentRouter: Router, private route: ActivatedRoute) {
            this.router = _parentRouter;
            this.transactionKey = route.snapshot.params['transactionKey'];
    }

    ngOnInit() {
        console.log("In Transaction Return Component -> NgOnInit");
        console.log(this.transactionKey);
        this._transactionReturnService.verifyTransaction(this.transactionKey).then(data => {
            console.log(data);
            if(data.code==1) {
                this.router.navigate(['/superuser', 'start']);
            }
            else {
                this.paymentFailed=true;
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/start/transaction_return/transaction-return.component.ts
 **/